import './ModuleCertificates.scss';
import Subtitle from 'components/TextComps/Subtitle';
import { CertificationTest } from 'types/module';
import { CertificateCard } from 'components/CertificateCard/CertificateCard';
import Paragraph from 'components/TextComps/Paragraph';
import { useTranslation } from 'react-i18next';

type ModuleCertificatesProps = {
  certificationTests: CertificationTest[];
};

export const ModuleCertificates = ({ certificationTests }: ModuleCertificatesProps) => {
  const { t } = useTranslation();

  return (
    <section className='certificates'>
      <div className='header'>
        <Subtitle className='title'>
          <>{t('CertificatesHeader', { ns: 'learningHub' })}</>
        </Subtitle>
      </div>

      <Paragraph className='paragraph'>
        <>{t('CertificatesText', { ns: 'learningHub' })}</>
      </Paragraph>
      <Paragraph className='paragraph'>
        <>{t('EarnYourCertificates', { ns: 'learningHub', what: certificationTests.length > 1 ? 'certificates' : 'certificate' })}</>
      </Paragraph>

      <div className='available-certificates'>
        {certificationTests &&
          certificationTests.map((test, index) => (
            <CertificateCard
              key={index}
              title={test.title}
              status={test.status}
              description={test.description}
              prerequisites={test.prerequisites}
            ></CertificateCard>
          ))}
      </div>
    </section>
  );
};
